export const mailToSupport = 'mailto:exchange-support@shopify.com';
